<template>
	<leaflet-line
		:points="points"
		:weight="width"
		:lineCap="lineCap"
		:color="color"
		:addArrows="addArrows"
		v-bind="{...computedLineStyle, ...$attrs}"
	/>
</template>
<script>
export default {
	name: 'TPolyLine',
	inheritAttrs: false,
	props: {
		points: {
			type: Array,
			default: () => ([]),
		},
		color: {
			type: String,
			default: 'blue'
		},
		width: {
			type: Number,
			default: 2
		},
		lineCap: {
			type: String,
			default: 'butt'
		},
		lineStyle: {
			type: String,
			default: 'dashed',
			validator(value) {
				return [ 'dashed', 'solid' ].indexOf(value) !== -1;
			}
		},
		addArrows: {
			type: Boolean
		}
	},
	computed: {
		computedLineStyle() {
			switch (this.lineStyle) {
			case 'dashed':
				return { dashArray: '6 2' };
			case 'solid':
			default:
				return {};
			}
		}
	}
};
</script>